import React from 'react';

export const Avatar = ({ 
  fullName, 
  size = 200, 
  backgroundColor = '#4F46E5', 
  textColor = '#FFFFFF',
  borderColor = '#FFFFFF',
  borderWidth = 2,
  fontSize
}) => {
  // Function to extract initials from full name
  const getInitials = (name) => {
    if (!name || typeof name !== 'string') return 'U';
    
    const words = name.trim().split(' ').filter(word => word.length > 0);
    
    if (words.length === 0) return 'U';
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    
    // Take first letter of first two words
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  const initials = getInitials(fullName);
  
  // Calculate font size based on avatar size if not provided
  const calculatedFontSize = fontSize || Math.round(size * 0.4);

  const avatarStyle = {
    width: `${size}px`,
    height: `${size}px`,
    
    color: textColor,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: `${calculatedFontSize}px`,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    userSelect: 'none',
    flexShrink: 0
  };

  return (
    <div className="bg-primary" style={avatarStyle}>
      {initials}
    </div>
  );
};